module.exports = __webpack_public_path__ + "img/zdly.fca843d.png";